import { render } from "./ShowLivescoringResultDialog.vue?vue&type=template&id=08f6e89e&scoped=true"
import script from "./ShowLivescoringResultDialog.vue?vue&type=script&lang=js"
export * from "./ShowLivescoringResultDialog.vue?vue&type=script&lang=js"

import "./ShowLivescoringResultDialog.vue?vue&type=style&index=0&id=08f6e89e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f6e89e"]])

export default __exports__